import React from 'react'
import { connect } from 'react-redux'
import { doGetSysHoliday, doSaveSysHoliday, doDeleteSysHoliday } from '../../reducers/actions'

class HolidayDiv extends React.Component {
    state = {}
    componentDidMount = () => {
        const { onClose, dispatch, id } = this.props
        dispatch(doGetSysHoliday({
            id,
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else if (initValues基本信息) {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        }))
    }

    handlerConfirm = () => {
        const { initValues基本信息, changedValues基本信息, id } = this.state
        const { onSave, onClose, dispatch } = this.props
        dispatch(doSaveSysHoliday({
            id,
            changedValues基本信息,
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        }))
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose, dispatch } = this.props

        Tyan.pubForm.showConfirm('确定要删除？', () =>
            dispatch(doDeleteSysHoliday({
                id,
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            })))
    }


    handlerClose = () => {
        const { changedValues基本信息 } = this.state
        const { onClose } = this.props
        if (!changedValues基本信息 || Object.keys(changedValues基本信息).length === 0) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0 && (values.节假日 || values.法定节假日)
    }

    fieldset基本信息 = () => {
        return [
            { _text: '节假日名称', minWidth: '90%', required: true },
            { _text: '法定节假日', minWidth: '90%', },
            { _text: '节假日', minWidth: '90%', },
            { _text: '节假日改工作日', minWidth: '90%', },
            // { _radio: '是否计薪', minWidth: '90%' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, id } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        return <Body data={this} maxWidth="1000"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
                    { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                    { _button: canSave ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(HolidayDiv)